export default __webpack_public_path__ + "static/backgroundFeatures-c8276c606229899791593d05da9c5990.jpg";